module.exports = __webpack_public_path__ + "assets/img/home_process.7b5eb2b0.png";